import { useCallback, useEffect } from "react";
import { useState } from "react";
import { request } from "../../httpClient";
export const useGetTravel = () => {
  const [travel, setTravel] = useState([]);

  const getTravel = useCallback(async (id: string) => {
    const result = await request({
      path: `trip/get-data?id=${id}`,
    });
    return result;
  }, []);

  return { travel, getTravel };
};
